var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccordion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5045 1.40039L19.4963 1.40039C21.2236 1.40039 22.6004 2.81628 22.6004 4.53372V7.73372C22.6004 9.45117 21.2236 10.8671 19.4963 10.8671H4.5045C2.77719 10.8671 1.40039 9.45117 1.40039 7.73372L1.40039 4.53372C1.40039 2.81628 2.77719 1.40039 4.5045 1.40039ZM19.4963 3.40039L4.5045 3.40039C3.90768 3.40039 3.40039 3.89475 3.40039 4.53372L3.40039 7.73372C3.40039 8.37269 3.90768 8.86706 4.5045 8.86706H19.4963C20.0931 8.86706 20.6004 8.37269 20.6004 7.73372V4.53372C20.6004 3.89475 20.0931 3.40039 19.4963 3.40039ZM4.5045 15.1337C3.90768 15.1337 3.40039 15.6281 3.40039 16.2671L3.40039 19.4671C3.40039 20.106 3.90768 20.6004 4.5045 20.6004L19.4963 20.6004C20.0931 20.6004 20.6004 20.106 20.6004 19.4671V16.2671C20.6004 15.6281 20.0931 15.1337 19.4963 15.1337L4.5045 15.1337ZM1.40039 16.2671C1.40039 14.5496 2.77719 13.1337 4.5045 13.1337L19.4963 13.1337C21.2236 13.1337 22.6004 14.5496 22.6004 16.2671V19.4671C22.6004 21.1845 21.2236 22.6004 19.4963 22.6004L4.5045 22.6004C2.77719 22.6004 1.40039 21.1845 1.40039 19.4671L1.40039 16.2671Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccordion);
export default __webpack_public_path__ + "static/media/accordion.53ec0788edcab3a15f369c17574d994d.svg";
export { ForwardRef as ReactComponent };